// extracted by mini-css-extract-plugin
export default {"container":"transactions_container__KLPkP"};